// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3i3g2","emails":"CreateEditClinics_emails__1xOLX","emailTagLabel":"CreateEditClinics_emailTagLabel__18WFx"};